import { render, staticRenderFns } from "./HomeContent.vue?vue&type=template&id=86e86570&scoped=true"
import script from "./HomeContent.vue?vue&type=script&lang=js"
export * from "./HomeContent.vue?vue&type=script&lang=js"
import style0 from "./HomeContent.vue?vue&type=style&index=0&id=86e86570&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e86570",
  null
  
)

export default component.exports